import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SettingsService } from 'src/app/services/settings.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { Assignment } from 'src/app/classes/assignment';
import { Prompt } from 'src/app/classes/prompt';
import { AiService } from 'src/app/services/ai.service';
import { ActivatedRoute, Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { TranslateFieldPipe } from 'src/app/pipes/translate-field.pipe';
import { FormGroup, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Customer } from 'src/app/classes/customer';
import { Title } from '@angular/platform-browser';
import { EmptyCartComponent } from './empty-cart/empty-cart.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  providers: [TranslateFieldPipe]
})

export class CategoriesComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('promptInput') promptInput!: ElementRef

  animatedDots = ''
  agentResponse = ''
  assignments: Assignment[] = []
  assignmentsAll: Assignment[] = []
  fa = fa
  firstPromptSent = false
  intervalId: any
  isMobile = /android|iphone|ipad|ipod|windows phone/i.test(navigator.userAgent)
  isTyping = false
  lastPrompt = ''
  now = new Date()
  platform = Capacitor.getPlatform()
  placeholderText = $localize`What do you need done? Just tell me.`
  prompt!: Prompt

  shiftForm = new FormGroup({
    date: new FormControl<null | string>(null, [Validators.required]),
    start_times: new FormControl<null | string[]>(null),
    assignment_id: new FormControl<null | number>(null, [Validators.required]),
    customer: new FormControl<null | Customer>(null, [Validators.required]),
    employee_id: new FormControl<null | number>(null),
    products: new FormControl<any>([]),
    notes: new FormControl('', { nonNullable: true }),
    discount_id: new FormControl<null | number>(null),
  })
  
  constructor(
    private aiService: AiService,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    public router: Router,
    private translateField: TranslateFieldPipe,
    private titleService: Title,
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0)
    
    this.titleService.setTitle($localize`Nuuduu - The best way to get things done`)

    if (localStorage.getItem('order')) {
      const order = JSON.parse(localStorage.getItem('order')!)

      this.shiftForm.patchValue(order)
    }

    this.route.queryParams.subscribe((params) => {
      // New order, remove old and generat enew chat ID
      if (params['new']) {
        const { new: _, ...otherParams } = params;
        this.router.navigate([], { queryParams: otherParams })
        
        if(localStorage.getItem('sales_chat_id') || this.shiftForm.controls.products.value.length > 0) {
          const modal = this.modalService.open(EmptyCartComponent, { centered: true,size: 'md' })
          
          modal.result.then((result) => {
            console.log(result)
            if(result == 'empty') {
              this.shiftForm.reset()
              console.log(this.shiftForm.value)
              this.cdRef.detectChanges()
            }
          })
        }
      }
    })

    // No chat ID, generate one
    if(!localStorage.getItem('sales_chat_id'))
      localStorage.setItem('sales_chat_id', uuidv4());

    this.settingsService.assignmentsPublic().subscribe(assignments => {
      this.assignmentsAll = assignments
    })

    this.aiService.prompt('customer_assignment_sales_agent').subscribe(result => {
      this.prompt = result as Prompt
    })

    this.intervalId = setInterval(() => {
      this.animatedDots = this.animatedDots.length < 3 ? this.animatedDots + '.' : '';
    }, 250);
  }

  ngAfterViewInit() {
    if(this.platform == 'web') {
      this.promptInput.nativeElement.focus()
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  agentSend() {
    const userPrompt = this.lastPrompt = this.stripHTML(this.promptInput.nativeElement.innerHTML)

    this.promptInput.nativeElement.innerHTML = ''
    this.agentResponse = ''
    this.firstPromptSent = true

    if (userPrompt.length > 0) {
      
      this.animatedDots = ''

      this.aiService.assignmentSalesAssistant(localStorage.getItem('sales_chat_id'), userPrompt).subscribe({
        next: (result) => {
          this.now = new Date()

          this.agentResponse = result.response

          if (result.categories) {
            this.assignments = this.assignmentsAll.filter(assignment => result.categories.includes(assignment.id))
          }
        },
        error: () => {
          this.agentResponse = $localize`I'm sorry, I couldn't process your request. Please try again.`
        }
      })
    }

    else {
      this.now = new Date()
      this.agentResponse = $localize`Please enter a message.`
    }
  }

  selectAssignment(assignment: Assignment) {
    this.router.navigate(['/', 'services', this.translateField.transform(assignment, 'slug')], {
      queryParams: { prompt: this.lastPrompt }
    }).then(() => { })
  }

  showAllAssignments() {
    this.assignments = [ ...this.assignmentsAll ]
  }

  stripHTML(html: string) {
    // Replace <br> tags with new lines
    const withNewLines = html.replace(/<br\s*\/?>/gi, '\n');
    // Remove all other HTML tags
    const strippedText = withNewLines.replace(/<\/?[^>]+(>|$)/g, '');
    return strippedText.trim();
  }

  navigateToOrder() {
    this.router.navigate(['/services', this.translateField.transform(this.assignmentsAll.find(assignment => assignment.id == this.shiftForm.controls.assignment_id.value), 'slug')], { fragment: 'order' })
  }
}
